import { Navbar, Container, Nav, NavDropdown, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import '../style/NavigationBar.css';

const NavigationBar = () => {
    return (
        <Navbar expand="lg" className='navbar'>
            <Container>
                <Navbar.Brand as={Link} to="/homepage">
                    <img
                        src={logo}
                        width="65"
                        height="65"
                        className="d-inline-block align-top me-2"
                        alt="Logo Syailendra Auction"
                    />
                    Syailendra Auction
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    {/* Semua item menu sekarang ada di dalam satu Nav */}
                    <Nav className="mx-auto align-items-center main-nav-links">
                        <NavDropdown title="Auction" id="lelang">
                            <NavDropdown.Item as={Link} to="/upcoming">Upcoming Auctions</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/featured">Featured Lots</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/pasthighlights">Past Highlights</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link as={Link} to="/selling">Selling</Nav.Link>
                        <NavDropdown title="About" id="Information">
                            <NavDropdown.Item as={Link} to="/about">About us</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/faq">Faq</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/bidincrement">Bid Increments</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/terms">Terms & Conditions</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                    </Nav>
                    {/* Tombol Bid Online, akan muncul terpisah di desktop dan di bawah di mobile */}
                    <Nav className="ms-auto">
                         <Button as={Link} to="https://bid.syailendra-auction.com/" variant="danger" className="bid-button">Bid Online</Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default NavigationBar;
